import React from 'react';
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { withRouter } from 'react-router'
import RateOutFitCardHOC from './RateOutFitCardHOC'
import RateOutFitCardStack from '../templates/RateOutFitCardStack'
import CheckLater from '../templates/CheckLater'
import MaleSweeps from '../templates/MaleSweeps'
import FemaleSweeps from '../templates/FemaleSweeps'
import FriendsThink from '../templates/FriendsThink'
import getSession from '../session'
import cookies from 'browser-cookies'
const sessionId = getSession().toString()
//console.log('sessionId', sessionId)


const _ = require('lodash')
const getSweepState = () => {
  return cookies.get('finerysweeps')
}
const nextCard = (gender, cardset) => {
    if(cardset === '2'){     
      return `/later`
    }else{
      return `/share/${gender}`
    }
}

const getCardData = (cards, cardset) => {

    if(cardset === '2'){
      cards = cards.slice(5,10)
      //console.log('cardData2', cards)
    }else{
      cards = cards.slice(0,5)
      //console.log('cardData1', cards)
    }
    return _.reverse(cards)
}

class RateOutFitCardStackHOC extends React.Component {

constructor(props) {
    super(props);
    this.state = { 
      cards: getCardData(this.props.cards, this.props.match.params.cardset),
      tagsVisible: false,
      selectedTags: [],
      cardIndex: 1

    }
    this.onItemRemove = this.onItemRemove.bind(this)
    this.setSelectedTags = this.setSelectedTags.bind(this)
    this.getSelectedTags = this.getSelectedTags.bind(this)

  }

componentWillReceiveProps(nextProps){
  //console.log('nextProps', nextProps)
  this.setState({cards: getCardData(nextProps.cards, nextProps.match.params.cardset)})
}

  onItemRemove = (rating, outfitId, tags) => {
    //console.log('onitemremove: sessionId', sessionId, 'rating', rating, 'outfitId', outfitId, 'tags', tags)
    const self = this
    const emptyTags = []
    self.setSelectedTags(emptyTags)
    self.updateCardCount()
    const gender = self.props.match.params.gender
    console.log('gender', gender)

    let submitRating = new Promise((resolve, reject) => {
        self.props.mutate({variables: {sessionId, rating, outfitId, tags, gender}})
        .then(() => {
          //console.log('sessionId', sessionId, 'rating', rating, 'outfitId', outfitId, 'tags', tags)
          resolve(outfitId)
        })

    })

    submitRating.then((outfitId) => {
      let newItems = _.clone(self.state.cards)
      _.remove(newItems, {id: outfitId})

      setTimeout(()=>{ 
      if(newItems.length < 1){
        const path = nextCard(self.props.match.params.gender, self.props.match.params.cardset)
        //add state info as very top to say rating has been made
        self.props.history.push(path)
      }else{
        self.setState({cards: newItems})
      }

      }, 400);

    })

  }

  setSelectedTags = (selectedTags) => {
    this.setState({selectedTags: selectedTags})
    if(selectedTags.length === 3){
      this.toggleTagsOverLay()
    }
  }


  getSelectedTags = () => {
    return this.state.selectedTags
  }

  toggleTagsOverLay = () => {
    let visible = this.state.tagsVisible
    if(visible === true){
      this.setState({tagsVisible: false})
    }else{
      this.setState({tagsVisible: true})
    }
  }

  getVisibleCard = (cardIndex) => {
    const currentCards = this.state.cards.length - 2
    //console.log('currentCard:', currentCard, 'cardIndex:', cardIndex)

    if(cardIndex >= currentCards){
      return true
    }
  }

  getActiveCard = (cardIndex) => {
    const currentCard = this.state.cards.length - 1
    //console.log('currentCard:', currentCard, 'cardIndex:', cardIndex)

    if(cardIndex === currentCard){
      return true
    }
  }

  getLastCard = () => {
    if(this.state.cards.length === 1){
      return 'lastCard'
    }
  }

  getVisibilityClass = (visibility) => {
    if(visibility === true){
      return 'active'
    }else{
      return ''
    }
  }

  updateCardCount = () => {
    const newIndex = this.state.cardIndex + 1
    this.setState({cardIndex: newIndex})
  }

  render() {

    const cards = this.state.cards.map((card, i) => {
        return (
          <RateOutFitCardHOC key={card.id} outfit={card} cardIndex={this.state.cardIndex} lastCardClass={this.getLastCard()} setSelectedTags={ this.setSelectedTags } toggleTagsOverLay={this.toggleTagsOverLay} onItemRemove={this.onItemRemove} tagsVisible={this.state.tagsVisible} visible={this.getVisibleCard(i)} active={this.getActiveCard(i)} />
        )
    })
    
    if(this.props.match.params.cardset === '2'){
      return (
          <RateOutFitCardStack selectedTags={ this.getSelectedTags() } onClickHandler={this.toggleTagsOverLay} visibleClass={this.getVisibilityClass(this.state.tagsVisible)} >
            <CheckLater />
            {cards}
          </RateOutFitCardStack>
        )
    }else{
      if(this.props.match.params.gender === 'm'){
        return (
          <RateOutFitCardStack selectedTags={ this.getSelectedTags() }  onClickHandler={this.toggleTagsOverLay} visibleClass={this.getVisibilityClass(this.state.tagsVisible)} >
            <FriendsThink gender={this.props.match.params.gender} />
            {cards}
          </RateOutFitCardStack>
        )
      }else{
        return (
          <RateOutFitCardStack selectedTags={ this.getSelectedTags() }  onClickHandler={this.toggleTagsOverLay} visibleClass={this.getVisibilityClass(this.state.tagsVisible)} >
            <FriendsThink gender={this.props.match.params.gender} />
            {cards}
          </RateOutFitCardStack>
        )
      }
      

    }
  }

}

const createRatingEntryMutation = gql`
  mutation createRatingEntry($sessionId: String!, $rating: Int!, $outfitId: String!, $tags: [String!], $gender: String) {
  createRatingEntry(sessionId: $sessionId, rating: $rating, outfitId: $outfitId, tags: $tags, gender: $gender) {
    sessionId
    rating
    outfitId
    tags
    gender
  }
}
`

const OutFitCardsWithMutation = graphql(createRatingEntryMutation)(withRouter(RateOutFitCardStackHOC))

export default OutFitCardsWithMutation



// WEBPACK FOOTER //
// ./src/components/RateOutFitCardStackHOC.js